import Table from "../../table/Table";
import Update from "../../table/Update";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { chackTitle, chackInstrumentTitle } from "../../../constants";
import { Container, Card, Button } from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import ApiService from "../../../services/apiService";
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify"; 
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { routes } from "../../../routers/routes";
import { set } from "date-fns";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";
import { format } from "date-fns";
import { Filter } from "react-feather";
import AddIcon from "../../svg/AddIcon";

const ChackInstrument = () => {
    const navigate = useNavigate();
    const role = useAppSelector((state: any) => state.role.role);
    const [chackInstrument, setChackInstrument] = useState<any>([]);
    const [selectedId, setSelectedId] = useState<string>("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
    let updatedData :any =[] 

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy
    } = usePagination({
        endpoint: `/chackinstrumentdetail`,
        filterOn:'Instrument',
         enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])


    /* useEffect(()=>{
         const fetchChackInstrument = async ()=>{
             const response = await ApiService.axiosApi("/chackinstrumentdetail");
         try{
              if(response.success){
                 setChackInstrument(response.data);
               }else{
                 toast.error(response.message|| "Failed to fetch Chack Instrument");
               }  
             }catch (error:any){
                 toast.error(error.message|| "Failed to fetch Chack Instrument");
             }
         }
         fetchChackInstrument();
     },[refresh])*/

     if(data){
         
            updatedData = data.map((time) =>{
             const formatDate =format(new Date(time.installationReplacementDate),'yyyy-MM-dd HH:mm:ss')

             return{
                ...time,
                installationReplacementDate:formatDate
             }
     })
     }
    const handleInstrumentUpdate = (id: string) => {
        navigate(`/chackinstrument-update/${id}`);
    }
    const handleDelete = (id: string) => {
        setSelectedId(id);
        setIsDeleteModalOpen(true);
    }
    const handleInstrumentDelete = async (id: string) => {
        try {
            const response = await ApiService.axiosApi(`/chackinstrumentdetail/${id}`, {
                method: "DELETE"
            })
            if (response.success) {
                toast.success(response.message || "Chack Instrument deleted successfully");
                setIsDeleteModalOpen(false)
                setRefresh(prev => !prev);
            } else {
                toast.error(response.message || "Failed to delete Chack Instrument");
            }
        } catch (error: any) {
            toast.error(error.message || "Failed to delete Chack Instrument");
        }

    }
    return (

        <>
            <Breadcrumbs mainTitle={chackInstrumentTitle} parent={chackTitle} />
            <div className="tables">

                <Card>
                    <CommonCardHeader title="Chak Instrument List" headClass="pb-3" />
                    <div className="d-flex justify-content-between">

                    <div style={{marginLeft:'10px'}} className='align-items-center justify-content-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('instrument')}>
                           <Filter/>
                       </button>
                           </div>
                        
                    </div>
                    {role === "Administrator" && (
                        <div className="d-flex justify-content-end " >
                        <Button onClick={() => navigate(routes.AddChackInstrument)} color="primary" size="md" className="mb-2 mx-1 px-2 me-4"><div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
              <AddIcon />
            </div></Button>
                    </div>
                    )}
                    </div>

                    <Table
                        data={updatedData}
                        columns={[
                            { header: "Instrument", accessor: "instrument" },
                            { header: "Make", accessor: "make" },
                            { header: "Model", accessor: "model" },
                            { header: "Installation/Replacement Date", accessor: "installationReplacementDate" },
                            { header: "Remark", accessor: "remark" }
                        ]}
                        buttons={[
                            { label: "Edit", onClick: handleInstrumentUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger" }
                        ]}
                    />
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>

                </Card>
                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Chack Instrument</ModalHeader>
                    <ModalBody>Are you sure you want to delete this chack instrument?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleInstrumentDelete(selectedId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    )
}
export default ChackInstrument;